import { Component, Input, OnInit } from '@angular/core';
import { DeviceBoDtoNBK } from 'src/app/api/nbk';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-device-type',
    templateUrl: './device-type.component.html',
    styleUrls: ['./device-type.component.scss'],
    imports: [NgClass]
})
export class DeviceTypeComponent implements OnInit {
  @Input() device: DeviceBoDtoNBK;
  
  constructor( ) {  }

  ngOnInit(): void { }


}
